export const config = {
  defaultLocale: 'en-AU',
  defaultCurrency: 'AUD',
  defaultDateFormat: 'DD/MM/YYYY',
  shortDateFormat: 'YYYY-MM-DD',
  fileNameFormat: 'DD-MM-YYYY',
  defaultTimeFormat: 'HH:mm',
  defaultTenantRegion: 'AU',
  isoDateFormat: 'YYYY-MM-DD',
  americanDateFormat: 'DD/MM/YY',
  screenDateFormat: 'DD/MM/YY',
  marginPrecision: 4,
  oneMillion: 1_000_000,
  env: process.env.NODE_ENV,
  auth: {
    cognitoUserPoolDomain: process.env.REACT_APP_COGNITO_USER_POOL_DOMAIN,
    cognitoUserPoolRegion: process.env.REACT_APP_COGNITO_USER_POOL_REGION,
    cognitoUserPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
  },
}
